import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
import { filter, take, timeout } from 'rxjs/operators';
import { FrontendLoggerService } from '../../../services/frontend-logger.service';

export class InviteOnboardingTokenVerifier {
  constructor(
    private readonly auth0: Auth0Service,
    private readonly logger: FrontendLoggerService
  ) {}

  async refreshAndWait(waitMs: number): Promise<boolean> {
    try {
      try {
        await firstValueFrom((this.auth0 as any).getAccessTokenSilently({ ignoreCache: true }));
      } catch {
        await firstValueFrom((this.auth0 as any).getAccessTokenSilently());
      }
    } catch (error) {
      this.logger.error(
        '[InviteWizard] Failed to silently refresh access token: '
          + String((error as any)?.message || error)
      );
      return false;
    }

    try {
      const claims = await firstValueFrom(
        (this.auth0 as any).idTokenClaims$.pipe(
          filter((value: any) => this.hasCompletedWizard(value)),
          take(1),
          timeout(waitMs)
        ) as any
      );
      return !!claims;
    } catch {
      return false;
    }
  }

  private hasCompletedWizard(claims: any): boolean {
    if (!claims) return false;
    const app = claims.app_metadata || {};
    return app.WizardCompleted === true
      || app.WizarCompleted === true
      || claims.WizardCompleted === true
      || claims.WizarCompleted === true;
  }
}
